module.exports = __webpack_public_path__ + "img/Pop-up_02_Chinese.87448a83.png";